import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import requestAttachmentsState from '../attachments/state/requestAttachments';
import requestCohortsState from '../cohorts/state/requestCohorts';
import requestDatasetsState from '../datasets/state/requestDatasets';
import requestFormState from '../forms/state/requestForm';
import requestSubscriptionsState from '../subscriptions/state/requestSubscriptions';
import requestWorkspacesState from '../workspaces/state/requestWorkspaces';
import requestsState from './request';
import tasksState from '../tasks/state/task';
import taskTemplatesState from '../tasks/templates/state/taskTemplates';
import workspacesState from '../workspaces/state/workspace';

const handlers = {
  ...requestAttachmentsState,
  ...requestCohortsState,
  ...requestDatasetsState,
  ...requestFormState,
  ...requestSubscriptionsState,
  ...requestWorkspacesState,
  ...requestsState,
  ...tasksState,
  ...taskTemplatesState,
  ...workspacesState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
